import React from 'react';
import Container from '../container/Container'
import './SuperAdminStyle.scss'
import {useAuthState} from "../context/AuthContext";
import {advanceSidebarItems} from "../component/Sidebar/SideBarItems";
import {CollapsedSidebar} from "@moeindal/base-raiko-panel-components";
import brandLogo from "../../src/assets/images/log_1.png"

export const SuperAdmin = () => {
    const {role: roles=[]} = useAuthState();


    return (
        <section className="main-division">
            <div className={"mainDivisionSidebarContainer"}>
                <CollapsedSidebar
                    advanceSidebarItems={advanceSidebarItems}
                    roles={roles}
                    hasBrand
                    brandTitle={"دیار مرد میدان"}
                    brandImage={brandLogo}
                    brandUrlAddress={"https://dmmkr.ir"}
                />
            </div>
            <Container/>
        </section>
    )
}
